import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { formatNumber, getInitials, getCachedMediaUrl } from '../../../../lib/utils/utils';
import { checkFollowing, followSeller, unfollowSeller } from '../../../../lib/utils/apiCalls';

function ProfileInfoBar() {
    const sellerInfo = useSelector((state) => state.lens.sellerInfo.sellerInfo);

    const storeData = useSelector((state) => state.lens.storeData.storeData);

    const [following, setFollowing] = useState(false);

    const handleFollowToggle = async () => {
        if(following) {
            try {
                await unfollowSeller(sellerInfo.id);
            }
            catch(err) {
                console.log(err);
            }
        }
        else {
            try {
                await followSeller(sellerInfo.id);
            }
            catch(err) {
                console.log(err);
            }
        }

        try {
            const response = await checkFollowing(sellerInfo.id);
            setFollowing(response);
        }
        catch(err) {
            console.log(err);
        }
    }

    useEffect(() => {
        const checkIfFollowing = async () => {
            if(sellerInfo.id && storeData.id) {
                if(sellerInfo.id !== storeData.id) {
                    try {
                        const response = await checkFollowing(sellerInfo.id);
                        setFollowing(response);
                    }
                    catch(err) {
                        console.log(err);
                    }
                }
            }
        }

        Object.keys(sellerInfo).length > 0 && checkIfFollowing();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sellerInfo]);

    return (
        <div className="flex items-center justify-between px-4 mx-5">
            <div className="flex items-center gap-[10px]">
                <div className="size-20 rounded-full overflow-hidden">
                    {
                        sellerInfo?.ProfilePic ? 
                        <img className='w-full h-full object-cover' src={getCachedMediaUrl(sellerInfo.ProfilePic)} alt="" /> : 
                        <div className='w-full h-full bg-[#EAEAEA] flex items-center justify-center'>
                            <p className='font-mulish select-none font-bold text-2xl text-[#666666]'>{getInitials(sellerInfo?.fullName || sellerInfo?.name)}</p>
                        </div>
                    }
                </div>

                <h1 className='font-semibold select-none text-[18px] leading-8 text-[#121212]'>
                    {sellerInfo?.fullName || sellerInfo?.name}
                </h1>

                {
                    storeData.id !== sellerInfo.id && 
                    <div className="px-[10px] py-1 text-[#121212]">
                        {
                            !following ? 
                            <button onClick={handleFollowToggle} className="select-none w-[120px] bg-primaryColor hover:bg-primaryAccent text-buttonText rounded-md px-3 py-[5px] font-bold text-[14px] leading-[26px]">Follow</button> : 
                            <button onClick={handleFollowToggle} className="select-none w-[120px] bg-[#E0E0E0] rounded-md px-3 py-[5px] font-bold text-[14px] leading-[26px]">Following</button>
                        }
                    </div>
                }
            </div>

            <div className="flex items-center gap-10 select-none">
                <div className="flex flex-col gap-1 items-center text-[#121212]">
                    {
                        sellerInfo?.Follower && 
                        <p className='font-bold text-[18px] leading-6'>{formatNumber(sellerInfo.Follower.length)}</p>
                    }

                    <h1 className='font-medium text-[14px] leading-6'>Followers</h1>
                </div>

                <div className="flex flex-col gap-1 items-center text-[#121212]">
                    {
                        sellerInfo?.Followed && 
                        <p className='font-bold text-[18px] leading-6'>{formatNumber(sellerInfo.Followed.length)}</p>
                    }

                    <h1 className='font-medium text-[14px] leading-6'>Following</h1>
                </div>

                {/* Commented for now */}
                {/* {
                    storeData.id === sellerInfo.id &&
                    <div className="flex flex-col gap-1 items-center text-[#121212]">
                        <p className='font-bold text-[18px] leading-6'>10k</p>

                        <h1 className='font-medium text-[14px] leading-6'>Favourites</h1>
                    </div>
                } */}

                {
                    storeData.id === sellerInfo.id &&
                    <div className="flex flex-col gap-1 items-center text-[#121212]">
                        {
                            sellerInfo?.posts && 
                            <p className='font-bold text-[18px] leading-6'>{formatNumber(sellerInfo.posts.length)}</p>
                        }

                        <h1 className='font-medium text-[14px] leading-6'>Posts</h1>
                    </div>
                }

                <div className="flex flex-col gap-1 items-center text-[#121212]">
                    {
                        (Object.keys(sellerInfo).length > 0) && 
                        <p className='font-bold text-[18px] leading-6'>{formatNumber(sellerInfo.Reviews)}</p>
                    }

                    <h1 className='font-medium text-[14px] leading-6'>Reviews{storeData.id !== sellerInfo.id ? '' : ' Received'}</h1>
                </div>

                {
                    storeData.id !== sellerInfo.id &&
                    <div className="flex flex-col gap-1 items-center text-[#121212]">
                        {
                            sellerInfo?.posts && 
                            <p className='font-bold text-[18px] leading-6'>{formatNumber(sellerInfo.posts.length)}</p>
                        }

                        <h1 className='font-medium text-[14px] leading-6'>Posts</h1>
                    </div>
                }
            </div>
        </div>
    );
}

export default ProfileInfoBar;
